import {Completable, completed, EmployeeSummaryDTO, pending} from 'kashable-mobile-common';

import {getEmployeeSummary} from '../apis/employee';
import {RootState} from '../store';

import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<EmployeeSummaryDTO> = pending();

export const fetchEmployee = createAsyncThunk('employee/fetch', async (employee, {rejectWithValue}) => {
    const response = await getEmployeeSummary();

    if (response.error) {
        rejectWithValue(response);
    }

    return response;
});

export const employeeSlice = createSlice({
    name: 'employee',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        update(state, action: PayloadAction<EmployeeSummaryDTO>) {
            return completed(action.payload);
        },
        clearEmployee: () => {
            return {...INITIAL_STATE};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployee.pending, () => {
                return pending();
            })
            .addCase(fetchEmployee.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const selectEmployee = (state: RootState) => state.employee;

export const {
    update,
    clearEmployee,
} = employeeSlice.actions;
export default employeeSlice.reducer;
